import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { RootState } from '../redux/store';
import { setPatientType } from '../redux/slices/appointmentSlice';
import { StepCard } from '../components/StepCard';
import { Button } from '../components/Button';
import { PatientTypeEnum } from '../types';

export const StepPatientType = () => {
  const selected = useSelector((s: RootState) => s.appointment.patientType);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const proceed = () => navigate(`../step-3`);

  return (
    <Layout>
      <div className="space-y-4">
        <div className='flex flex-col items-center text-center md:items-start md:text-start'>
          <h1 className="text-2xl font-semibold text-black">Patient type</h1>
          <p className="text-sm text-gray-500">Are you a new patient or have you visited us before?</p>
        </div>
        <StepCard>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-black">
            {Object.values(PatientTypeEnum).map((t) => (
              <button
                key={t}
                onClick={() => dispatch(setPatientType(t))}
                className={`card bg-white shadow-sm p-6 border rounded-lg ${selected === t ? 'border-teamcare-blue ring-2 ring-teamcare-blue/20' : 'border-gray-200'}`}
              >
                <div className="text-center font-medium capitalize">{t} patient</div>
              </button>
            ))}
          </div>
        </StepCard>
        <div className="flex justify-between">
          <Button title='Back' variant='secondary' onClick={() => navigate('../step-1')} />
          <Button title='Continue' disabled={!selected} onClick={proceed} />
        </div>
      </div>
    </Layout>
  );
};




